/* global ajax_localize */

import { WOW } from "wowjs";

(function ($, ajax_localize) {
    $(document).ready(function () {
        const wow = new WOW();

        wow.init();

        let headerScrollTopOffset = 0;

        if ($("body").hasClass("admin-bar") && $(window).width() > 600) {
            headerScrollTopOffset = $("html").css("margin-top");
        }

        // Set header navbar height
        calculateNavbarHeight();
        calculateTopBannerHeight();

        equalCarouselSlideHeights(
            ".carousel-block .carousel, .spotlight-carousel-block .spotlight-text-carousel"
        );
        testimonialEqualHeights();

        let resizeThrottled = false;

        $(window).on("resize", function () {
            if (!resizeThrottled) {
                calculateNavbarHeight();
                calculateTopBannerHeight();

                resizeThrottled = true;

                setTimeout(function () {
                    resizeThrottled = false;

                    calculateNavbarHeight();
                    calculateTopBannerHeight();
                }, 100);
            }
        });

        // Watch for when header is scrolled to or away from the top of the viewport
        // If header is scrolled to the top of the page, we know it's been stickied based on it having position: sticky
        // Add class when it's sitting at the top of the page, remove it when it's been scrolled away
        $("body > header")
            .observeScrollTopChanges(headerScrollTopOffset)
            .on("scroll-top-change", (evt) => {
                $(evt.target).toggleClass("sticky", evt.detail.scrolledToTop);
            });

        let desktopMenuBreakpoint = 1099;

        /**
         * Desktop menu dropdowns
         */
        $(".menu-item-has-children")
            .find(".dropdown-toggle")
            .attr("data-toggle", "");

        // When hovering over a menu item, check for any other menu items at the same level that have a ".focus" class and remove it
        $("#header-navbar-menu-wrapper")
            .find(".menu-item")
            .on("mouseenter", function () {
                $("#header-navbar-menu-wrapper")
                    .find(".menu-item.dropdown.focus")
                    .removeClass("focus");
            });

        $("#header-navbar-menu-wrapper")
            .find(".menu-item.dropdown")
            .on("mouseenter", function () {
                fadeInMenuDropdown($(this).children(".dropdown-menu"));
            })
            .on("mouseleave", function () {
                fadeOutMenuDropdown($(this).children(".dropdown-menu"));
            })
            .on("focusout", function () {
                let thisDropdown = $(this);

                setTimeout(function () {
                    if (thisDropdown.find(".nav-link:focus").length === 0) {
                        thisDropdown.removeClass("focus");
                    }
                }, 100);
            });

        $("#header-navbar-menu-wrapper")
            .find(".menu-item > .nav-link")
            .on("focus", function () {
                $(this)
                    .parent()
                    .siblings(".menu-item.dropdown")
                    .find(".focus")
                    .addBack()
                    .removeClass("focus");
            });

        $("#header-navbar-menu-wrapper")
            .find(".menu-item.dropdown > .nav-link")
            .on("focus", function () {
                $(this).parent().addClass("focus");
            });

        /**
         * Mobile menu
         */

        $("header .js-mobile-menu-toggle").on("click", function () {
            $("body").toggleClass("no-scroll");
        });

        // Check the mobile menu status when resize the
        $(document).ready(function () {
            updateMobileMenu();
            $(window).resize(function () {
                updateMobileMenu();
            });
        });

        function updateMobileMenu() {
            if (
                !$("ul.dropdown-menu").hasClass("mobile-menu-sub-level-panel")
            ) {
                if ($(window).width() < desktopMenuBreakpoint) {
                    $("#header-navbar-menu-wrapper")
                        .find(
                            ".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu"
                        )
                        .each(function () {
                            $(this).addClass("mobile-menu-sub-level-panel");
                            let subLevelTitleElement = $("<h3>").html(
                                $(this).siblings(".nav-link").html().trim()
                            );
                            $(this).prepend(
                                $("<li>")
                                    .addClass(
                                        "menu-item sub-level-panel-heading"
                                    )
                                    .append(subLevelTitleElement)
                            );
                        });
                }
            }
        }

        $("#header-navbar-menu-wrapper.navbar-collapse")
            .on("show.bs.collapse", function () {
                let headerBannerHeight = 0;

                $("body > header")
                    .children(":not(#header-search-overlay)")
                    .each(function () {
                        headerBannerHeight += $(this).outerHeight();
                    });

                if (!$("body > header").hasClass("sticky")) {
                    headerBannerHeight +=
                        parseInt($("html").css("margin-top")) -
                        $("html").scrollTop();
                }

                $(this).css(
                    "--mobile-menu-height",
                    $(window).outerHeight() - headerBannerHeight + "px"
                );

                $(this)
                    .children(".header-navbar-menu-inner-wrap")
                    .addClass("curr-level");
            })
            .on("hidden.bs.collapse", function () {
                $(this).find(".curr-level").removeClass("curr-level");

                $(this).find(".show").removeClass("show fade-in");

                $(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

                $(this).find(".js-menu-back-btn").data("depth-level", 0);
            });

        let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(
            ".back-btn-wrap"
        );
        let mobileMenuBackBtn =
            mobileMenuBackBtnWrap.children(".js-menu-back-btn");

        mobileMenuBackBtn.data("depth-level", 0);

        mobileMenuBackBtn.on("click", function () {
            $(this).data("depth-level", $(this).data("depth-level") - 1);

            let currentMenuPanel = $("#header-navbar-menu-wrapper").find(
                ".mobile-menu-sub-level-panel.curr-level"
            );

            currentMenuPanel
                .parent()
                .closest(".mobile-menu-sub-level-panel")
                .addClass("curr-level");

            currentMenuPanel
                .addClass("fade-out")
                .removeClass("show fade-in curr-level");

            if ($(this).data("depth-level") <= 0) {
                $("#header-navbar-menu-wrapper")
                    .find(".header-navbar-menu-inner-wrap")
                    .addClass("curr-level");

                $(this)
                    .data("depth-level", 0)
                    .parent()
                    .addClass("fade-out")
                    .removeClass("show fade-in");
            }
        });

        // sub menu
        if ($(window).width() > 1099) {
            // on desktop for .remove-first-submenu items, remove the first link in the second level submenu
            $("#header-navbar-menu-wrapper")
                .find(
                    ".navbar-nav .menu-item.menu-item-has-children.remove-first-submenu > ul.dropdown-menu"
                )
                .each(function () {
                    $(this).find("li").first().remove();
                });
        } else {
            // mobile
            $("#header-navbar-menu-wrapper")
                .find(
                    ".navbar-nav .menu-item.menu-item-has-children > .nav-link"
                )

                .on("click", function (evt) {
                    evt.preventDefault();

                    $("#header-navbar-menu-wrapper")
                        .find(".curr-level")
                        .removeClass("curr-level");

                    $(this)
                        .siblings(".mobile-menu-sub-level-panel")
                        .scrollTop(0)
                        .removeClass("fade-out")
                        .addClass("show fade-in curr-level");

                    if (mobileMenuBackBtn.data("depth-level") === 0) {
                        mobileMenuBackBtnWrap
                            .removeClass("fade-out")
                            .addClass("show fade-in");
                    } else {
                        $(this)
                            .siblings(".mobile-menu-sub-level-panel")
                            .css(
                                "top",
                                $(this)
                                    .closest(
                                        ".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap"
                                    )
                                    .scrollTop()
                            );
                    }

                    mobileMenuBackBtn.data(
                        "depth-level",
                        mobileMenuBackBtn.data("depth-level") + 1
                    );

                    return false;
                });
        }

        /**
         * Header search overlay
         */
        $("#header-search-overlay").addClass("fade");

        $(".header-navbar .btn-search").on("click", function () {
            $("#header-search-overlay").addClass("show");

            let headerPositionData = $(".site-header-wrap")
                .get(0)
                .getBoundingClientRect();

            $("<div>")
                .addClass("modal-backdrop header-search-overlay-backdrop")
                .css("opacity", 0) // Temporary
                .css(
                    "top",
                    headerPositionData.y +
                        $("#header-search-overlay").outerHeight() +
                        parseInt($("#header-search-overlay").css("top"))
                )
                .appendTo($("body"))
                .fadeTo(150, 0.9);

            $("body").addClass("modal-open");

            setTimeout(function () {
                $("#header-search-overlay .search-input").focus();
            }, 300);
        });

        $("#js-header-search-overlay-close").on("click", function () {
            $("#header-search-overlay")
                .removeClass("show")
                .find(".search-input")
                .blur();

            $(".header-search-overlay-backdrop").fadeOut(
                200,
                "linear",
                function () {
                    $(this).remove();
                }
            );

            $("body").removeClass("modal-open");
        });

        /**
         * Video modals
         */
        $(".video-modal").appendTo("body");

        /**
         * Video modal buttons within carousels
         *
         * TODO Move to Orange
         *
         */
        $(".carousel .btn-video-modal").on("click", function () {
            let parentCarousel = $(this).closest(".carousel");

            let wasCarouselCycling = parentCarousel.is(
                "[data-ride='carousel']"
            );

            parentCarousel.carousel("pause");

            $($(this).data("target")).on("hide.bs.modal", function () {
                if (wasCarouselCycling) {
                    parentCarousel.carousel("cycle");
                }
            });
        });

        /**
         * Back to top button - scroll functionality
         */
        $("#back-to-top")
            .addClass("fade")
            .on("click", function () {
                $("html, body").animate(
                    {
                        scrollTop: 0,
                    },
                    400
                );
            });

        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("#back-to-top").addClass("show");
            } else {
                $("#back-to-top").removeClass("show");
            }
        });

        $(".newsletter-signup-toggle-btn").on("click", function () {
            $(this)
                .closest(".newsletter-sign-up-section")
                .css(
                    "min-height",
                    $(this).closest(".newsletter-sign-up-section").outerHeight()
                );
        });

        /**
         * Social slider
         */
        $.each(
            $(".social-slider-block .social-slider"),
            function (index, slider) {
                var sliderID = "#" + $(slider).attr("id");
                /*
				CC 2.0 License Iatek LLC 2018 - Attribution required
			*/
                $(this).on("slide.bs.carousel", function (e) {
                    var $e = $(e.relatedTarget);
                    var idx = $e.index();
                    var itemsPerSlide = 6;
                    var totalItems = $(sliderID + " .carousel-item").length;

                    if (idx >= totalItems - (itemsPerSlide - 1)) {
                        var it = itemsPerSlide - (totalItems - idx);
                        for (var i = 0; i < it; i++) {
                            // append slides to end
                            if (e.direction === "left") {
                                $(sliderID + " .carousel-item")
                                    .eq(i)
                                    .appendTo(sliderID + " .carousel-inner");
                            } else {
                                $(sliderID + " .carousel-item")
                                    .eq(0)
                                    .appendTo(sliderID + " .carousel-inner");
                            }
                        }
                    }
                });
            }
        );

        /**
         * Social Slider - Link functionality
         */
        $.each(
            $(
                ".social-slider-block .carousel .carousel-inner .carousel-item .social-item"
            ),
            function () {
                let postLink = $(this).attr("data-link");

                $(this).on("click", function () {
                    window.open(postLink, "_blank").focus();
                });
            }
        );

        /**
         * Spotlight carousel
         */
        $(".spotlight-carousel-block .spotlight-image-carousel").each(
            function () {
                if (
                    $(window).width() >=
                    parseInt($(":root").css("--breakpoint-lg"))
                ) {
                    if ($(this).find(".carousel-item").length === 2) {
                        $(this)
                            .find(".carousel-item")
                            .clone()
                            .removeClass("active")
                            .appendTo($(this).find(".carousel-inner"));
                    }

                    $(this)
                        .find(".carousel-item.active")
                        .next()
                        .addClass("carousel-item-next");

                    $(this)
                        .find(".carousel-item:not(.active) .btn-video-modal")
                        .prop("disabled", true);

                    let numSlides = $(this).find(".carousel-item").length;

                    $(this)
                        .on("slide.bs.carousel", function (evt) {
                            if (evt.direction === "left") {
                                let nextNextItemIndex = evt.to + 1;

                                if (nextNextItemIndex > numSlides - 1) {
                                    nextNextItemIndex = 0;
                                }

                                let nextNextCarouselItem = $(this)
                                    .find(".carousel-item")
                                    .eq(nextNextItemIndex);

                                nextNextCarouselItem
                                    .addClass("carousel-item-next-next")
                                    // This reflows the element, meaning the browser will calculate the styles and layout of the element
                                    // Any classes added after this will then trigger any transitions associated with the class
                                    // This avoids any delays caused by the "wait a tick" method
                                    .outerHeight();

                                nextNextCarouselItem.addClass(
                                    "carousel-item-left"
                                );
                            } else if (evt.direction === "right") {
                                $(this)
                                    .find(".carousel-item.carousel-item-next")
                                    .addClass("carousel-item-right");

                                $(this)
                                    .find(".carousel-item.active")
                                    .addClass("carousel-item-next");
                            }

                            if (
                                $(this)
                                    .find(".carousel-item")
                                    .eq(evt.from)
                                    .has(".btn-video-modal").length > 0
                            ) {
                                $(this)
                                    .find(".carousel-item")
                                    .eq(evt.from)
                                    .find(".btn-video-modal")
                                    .prop("disabled", true);
                            }
                        })
                        .on("slid.bs.carousel", function (evt) {
                            if (evt.direction === "left") {
                                $(this)
                                    .find(
                                        ".carousel-item.carousel-item-next-next"
                                    )
                                    .removeClass(
                                        "carousel-item-next-next carousel-item-left"
                                    )
                                    .addClass("carousel-item-next");
                            } else if (evt.direction === "right") {
                                $(this)
                                    .find(".carousel-item-right")
                                    .removeClass("carousel-item-right");

                                let oldNextItemIndex = evt.from + 1;

                                if (oldNextItemIndex > numSlides - 1) {
                                    oldNextItemIndex = 0;
                                }

                                $(this)
                                    .find(".carousel-item")
                                    .eq(oldNextItemIndex)
                                    .removeClass("carousel-item-next");
                            }

                            if (
                                $(this)
                                    .find(".carousel-item")
                                    .eq(evt.to)
                                    .has(".btn-video-modal").length > 0
                            ) {
                                $(this)
                                    .find(".carousel-item")
                                    .eq(evt.to)
                                    .find(".btn-video-modal")
                                    .prop("disabled", false);
                            }
                        });
                }
            }
        );

        /**
         * Single post scrolling progress bar
         */
        if ($("body").hasClass("single")) {
            updateSinglePostProgressBar();

            $(window).scroll(function () {
                updateSinglePostProgressBar();
            });
        }

        /**
         * Single post: make all external links open in a new tab
         */
        if ($("body").hasClass("single-post")) {
            $(".the-content a[href]").each(function () {
                // first check if the href includes http(s) to filter out relative links
                if ($(this).attr("href").includes("http")) {
                    // now check if the hostname of the link is the same as the site's hostname
                    let hrefDomain = new URL($(this).attr("href")).hostname;
                    if (
                        location.hostname !== hrefDomain &&
                        "bluedoor.ca" !== hrefDomain &&
                        "www.bluedoor.ca" !== hrefDomain
                    ) {
                        $(this).attr("target", "_blank");
                    } else {
                        // force absolute internal links to open in the same tab
                        $(this).attr("target", "_self");
                    }
                } else {
                    // force relative links to opwn in the same tab
                    $(this).attr("target", "_self");
                }
            });
        }

        // FAQs page "Load More" buttons
        /* eslint-disable-next-line */
        if (ajax_localize.hasOwnProperty("ajax_url")) {
            $(".page-faqs .btn-faq-load-more").each(function () {
                var listItemHolder = $(this).siblings(".faq-accordion");

                // Hide the button if there aren't any more posts to load
                if ($(".list-items-loader", listItemHolder).length < 1) {
                    $(this).hide();
                }

                $(this).on("click", function (evt) {
                    evt.preventDefault();

                    var loadMoreBtn = $(this);
                    var listItemLoader = $(
                        ".list-items-loader",
                        listItemHolder
                    );

                    // Save the button's text so we can restore it when removing the loading state
                    var origButtonText = loadMoreBtn.html();

                    if (loadMoreBtn.is(".loading")) {
                        return false;
                    }

                    loadMoreBtn
                        .attr("disabled", true)
                        .addClass("loading")
                        .text("Loading...");

                    var action = "get_faqs";

                    // Check if the list item loader has a custom action set
                    if (
                        listItemLoader.data("action") !== undefined &&
                        listItemLoader.data("action") !== ""
                    ) {
                        action = listItemLoader.data("action");
                    }

                    $.post(
                        ajax_localize.ajax_url,
                        {
                            action: action,
                            data: $.param(listItemLoader.data()),
                        },
                        function (data) {
                            // Remove the existing list item loader since a new one will be included in the response
                            listItemLoader.remove();

                            // If new faq items were returned
                            if (data) {
                                loadMoreBtn
                                    .attr("disabled", false)
                                    .removeClass("loading")
                                    .html(origButtonText);

                                var newFAQItems = $($.parseHTML(data));

                                newFAQItems
                                    .filter(":not(.list-items-loader)")
                                    .addClass("fade");

                                listItemHolder.append(newFAQItems);

                                // Wait a split second before adding class to fade in new faqs
                                setTimeout(function () {
                                    newFAQItems.addClass("show");
                                }, 100);

                                // Look for the new list item loader tag
                                // If it's not there, there aren't any more posts to show so hide the load more button
                                if (
                                    $(".list-items-loader", listItemHolder)
                                        .length < 1
                                ) {
                                    loadMoreBtn.remove();
                                }
                            } else {
                                loadMoreBtn.fadeOut(400, function () {
                                    $(this).remove();
                                });

                                $(".no-more-results-msg").show();
                            }
                        }
                    );
                });
            });
        }

        //add a class to icon columns to differentiate between icons and images
        $("section.icon-columns-block div.image-wrap")
            .closest(".icon-column")
            .addClass("has-image");
    });

    // FAQ Categories on mobile
    $("#faq-categories-dropdown").on("change", function () {
        if ($(this).val()) {
            window.location.href = $(this).val();
        }

        return false;
    });

    /**
     * Carousel - Set equal heights to captions on mobile
     */
    let equalCarouselSlideHeights = function (carouselSelector) {
        $(carouselSelector).each(function () {
            var items = $(".carousel-item", this);
            let maxHeight = 0;

            // Show all slides
            $.each(items, function (i, slide) {
                $(this).css("height", "");
                $(".carousel-caption", this).css("height", "");

                $(slide).addClass("active");
            });

            // Get the height of the tallest caption and save it
            $.each(items, function () {
                let caption = $(".carousel-caption", this);
                let captionHeight = caption.outerHeight();

                if (captionHeight > maxHeight) {
                    maxHeight = captionHeight;
                }
            });

            // Apply the max height to all captions
            $.each(items, function () {
                if (
                    $(window).width() >=
                    parseInt($(":root").css("--breakpoint-lg"))
                ) {
                    $(this).css("height", maxHeight);
                } else {
                    $(".carousel-caption", this).css("height", maxHeight);
                }

                // Remove .active from all slides
                $(this).removeClass("active");
            });

            // Add the active class back to the first slide
            $(".carousel-inner .carousel-item:first-of-type", this).addClass(
                "active"
            );
        });
    };

    /**
     * Testimonial - Set equal heights
     */
    let testimonialEqualHeights = function () {
        $(".testimonial-large-block, .testimonial-block").each(function () {
            var items = $(".carousel-item", this);
            let maxHeight = 0;

            // Show all slides
            $.each(items, function (i, slide) {
                $(slide).addClass("active");
            });

            // Get the height of the tallest caption and save it
            $.each(items, function () {
                let caption = $(".card-body", this);
                let captionHeight = caption.outerHeight();

                if (captionHeight > maxHeight) {
                    maxHeight = captionHeight;
                }
            });

            // Apply the max height to all captions
            $.each(items, function () {
                let caption = $(".card-body", this);
                caption.css("height", maxHeight);

                // Remove .active from all slides
                $(this).removeClass("active");
            });

            // Add the active class back to the first slide
            $(
                ".testimonial-large-block .carousel-inner .carousel-item:first-of-type, .testimonial-block .carousel-inner .carousel-item:first-of-type"
            ).addClass("active");
        });
    };

    // Run equal heights
    testimonialEqualHeights();

    let calculateNavbarHeight = function () {
        let navbarHeight = 0;

        if (
            $("#header-search-overlay").is(":visible") &&
            $(window).width() >= parseInt($(":root").css("--breakpoint-lg"))
        ) {
            navbarHeight = $("#header-search-overlay").outerHeight();
        } else {
            $("body > header")
                .children(":not(#header-search-overlay)")
                .each(function () {
                    if ($(this).is(":visible")) {
                        navbarHeight += $(this).outerHeight();
                    }
                });
        }

        $("body > header").css("--header-navbar-height", navbarHeight + "px");
    };

    let calculateTopBannerHeight = function () {
        let topBannerHeight = $(
            "body > header .header-top-banner"
        ).outerHeight();

        $("body > header").css(
            "--header-top-banner-height",
            topBannerHeight + "px"
        );
    };

    let fadeInMenuDropdown = function (dropdown) {
        if (
            $(window).width() >=
            parseInt($(":root").css("--desktop-menu-breakpoint"))
        ) {
            dropdown.removeClass("fade-out").addClass("fade-in");
        }
    };

    let fadeOutMenuDropdown = function (dropdown) {
        if (
            $(window).width() >=
            parseInt($(":root").css("--desktop-menu-breakpoint"))
        ) {
            dropdown.removeClass("fade-in").addClass("fade-out");
        }
    };

    let updateSinglePostProgressBar = function () {
        let article = $(".content-single .post");

        if (article.length > 0) {
            let articleBottom = Math.round(
                article.offset().top + article.outerHeight()
            );

            let windowScrollBottom =
                $(window).innerHeight() + $(window).scrollTop();

            let scrollProgressBarPercentage =
                Math.round((windowScrollBottom / articleBottom) * 10000) / 100;

            if (scrollProgressBarPercentage > 100) {
                scrollProgressBarPercentage = 100;
            }

            $(".content-single .post .scroll-progress-bar").css(
                "width",
                scrollProgressBarPercentage + "%"
            );
        }
    };

    // Fires event when element has scrolled up to or away from the top of it's parent
    $.fn.observeScrollTopChanges = function () {
        // Top and bottom margin values position marker element at the top of the box area of the current element, regardless of it's top margin
        // Need to increase bottom margin's negative value by 1px to compensate for marker's height
        // Essentially makes the marker invisible
        const marker = $("<div>").css({
            "margin-top": this.css("marginTop"),
            "margin-bottom": (parseInt(this.css("marginTop")) + 1) * -1,
            height: "1px",
        });

        // Add to DOM before element being observed
        // When marker is hidden beyond the top of the viewport, the target element will be touching the top of the viewport
        this.before(marker);

        // Create observer object
        const scrollTopObserver = new IntersectionObserver(
            (entries) => {
                // Width, height and scroll position of element being observed
                const targetBoundingRect = entries[0].boundingClientRect;
                // Width height and position of viewport
                const viewportBoundingRect = entries[0].rootBounds;

                // The element that should have the event triggered on it
                // Basically, the element that we want to know when it has reached the top of the page on scroll
                const evtTrigger = entries[0].target.nextSibling;

                let scrolledToTop = false;

                // If the entire marker element has scrolled beyond the top of the viewport
                if (targetBoundingRect.bottom < viewportBoundingRect.top) {
                    scrolledToTop = true;

                    // If the entire marker element is visible again
                } else if (
                    targetBoundingRect.bottom >= viewportBoundingRect.top
                ) {
                    scrolledToTop = false;
                }

                // Create custom event and pass information about whether the element was just hit the top of the page or if it is being scrolled away
                const evt = new CustomEvent("scroll-top-change", {
                    detail: { scrolledToTop: scrolledToTop },
                });

                evtTrigger.dispatchEvent(evt);

                // Threshold says how much of the element needs to be visible before checking for intersection
                // 0 means as soon as any part of the element is visible
            },
            { threshold: [0] }
        );

        // Start observing the marker element
        scrollTopObserver.observe(marker.get(0));

        // Return current element to allow for jQuery function chaining
        return this;
    };
})(jQuery, ajax_localize);
